export type CharacterChatPeer = {
  id: string;
  name: string;
  relevance?: number;
};

export const CHARACTER_CHAT_NARRATOR_VALUE = '__narrator__';

export function sortCharacterChatPeersByRelevance(
  peers: CharacterChatPeer[]
): CharacterChatPeer[] {
  return [...peers].sort((a, b) => {
    const relevanceDiff = (b.relevance ?? 0) - (a.relevance ?? 0);
    if (relevanceDiff !== 0) {
      return relevanceDiff;
    }
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
  });
}
